<nz-modal [(nzVisible)]="isVisible" nzTitle="View Supplier" (nzOnCancel)="handleCancel()" footer={null}>
  <ng-container *nzModalContent>
    <section id="supplierDetails" class="mt-5">
      <div>
        <div class="mt-5 grid md:grid-cols-1  gap-8">

          <div>
            <div class="sub-section" style="height: 100%">
              <div class="item-row">
                <p class="subject-name">Name</p>
                <p class="subject-data" *ngIf="!loading">{{supplierData?.supplierDetails?.name}}</p>
                  <nz-skeleton-element
                    *ngIf="loading"
                    nzType="input"
                    [nzActive]="true"
                    [nzSize]="'small'"
                    style="width:300px"
                  ></nz-skeleton-element>
              </div>
              <div class="item-row">
                <p class="subject-name">Mobile Number</p>
                <p class="subject-data clickable-mail-phone_no" *ngIf="!loading"><a class="clickable-mail-phone_no" href="{{supplierData?.supplierDetails?.mobileNo}}">{{supplierData?.supplierDetails?.mobileNo}}</a></p>
                <nz-skeleton-element
                  *ngIf="loading"
                  nzType="input"
                  [nzActive]="true"
                  [nzSize]="'small'"
                  style="width:300px"
                ></nz-skeleton-element>
              </div>
              <div class="item-row">
                <p class="subject-name">Email</p>
                <p class="subject-data clickable-mail-phone_no" *ngIf="!loading"><a class="clickable-mail-phone_no" href="{{supplierData?.supplierDetails?.email}}">{{supplierData?.supplierDetails?.email}}</a></p>
                <nz-skeleton-element
                  *ngIf="loading"
                  nzType="input"
                  [nzActive]="true"
                  [nzSize]="'small'"
                  style="width:300px"
                ></nz-skeleton-element>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section id="paymentDetails" class="mt-5">
      <div>
        <h5 class="text-black">Payment Details</h5>
        <div class="mt-5  gap-8">

          <div>
            <div class="sub-section" style="height: 100%">
              <div class="item-row">
                <p class="subject-name">Bank Name</p>
                <p class="subject-data" *ngIf="!loading">{{supplierData?.paymentDetails?.bankName}}</p>
                <nz-skeleton-element
                  *ngIf="loading"
                  nzType="input"
                  [nzActive]="true"
                  [nzSize]="'small'"
                  style="width:300px"
                ></nz-skeleton-element>
              </div>
              <div class="item-row">
                <p class="subject-name">Branch Name</p>
                <p class="subject-data" *ngIf="!loading">{{supplierData?.paymentDetails?.branch}}</p>
                <nz-skeleton-element
                  *ngIf="loading"
                  nzType="input"
                  [nzActive]="true"
                  [nzSize]="'small'"
                  style="width:300px"
                ></nz-skeleton-element>
              </div>
            </div>
          </div>

          <div>
            <div class="sub-section" style="height: 100%">
              <div class="item-row">
                <p class="subject-name">Account Type</p>
                <p class="subject-data" *ngIf="!loading">{{supplierData?.paymentDetails?.accountType}}</p>
                <nz-skeleton-element
                  *ngIf="loading"
                  nzType="input"
                  [nzActive]="true"
                  [nzSize]="'small'"
                  style="width:300px"
                ></nz-skeleton-element>
              </div>
              <div class="item-row">
                <p class="subject-name">Account Holders name</p>
                <p class="subject-data" *ngIf="!loading">{{supplierData?.paymentDetails?.holderName}}</p>
                <nz-skeleton-element
                  *ngIf="loading"
                  nzType="input"
                  [nzActive]="true"
                  [nzSize]="'small'"
                  style="width:300px"
                ></nz-skeleton-element>
              </div>
              <div class="item-row">
                <p class="subject-name">Account Number</p>
                <p class="subject-data" *ngIf="!loading">{{supplierData?.paymentDetails?.accountNo}}</p>
                <nz-skeleton-element
                  *ngIf="loading"
                  nzType="input"
                  [nzActive]="true"
                  [nzSize]="'small'"
                  style="width:300px"
                ></nz-skeleton-element>
              </div>
            </div>
          </div>

          <div>
            <div class="sub-section" style="height: 100%">
              <div>
                <p class="subject-name">Attachments</p>
                <div *ngIf="supplierData?.paymentAttachment?.length > 0 && !loading">
                  <div class="mt-2" *ngFor="let item of supplierData.paymentAttachment">
                    <a [href]="item.url" class="flex" target="_blank">
                      <img src="assets/img/file.png" alt="file">
                      <p class="pl-3">{{item.name}}</p>
                    </a>
                  </div>
                </div>
                <div *ngIf="!supplierData?.paymentAttachment?.length && !loading"> - </div>
                <nz-skeleton-element
                  *ngIf="loading"
                  nzType="input"
                  [nzActive]="true"
                  [nzSize]="'small'"
                  style="width:300px"
                ></nz-skeleton-element>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  </ng-container>
  <ng-container *nzModalFooter>
  </ng-container>
</nz-modal>
